import { createApp } from 'vue';
import SendlistApp from './sendlist/SendlistApp.vue';

export default function initSendlistBlock() {
    [].slice.apply(document.querySelectorAll('.sendlist')).forEach(initBlock);
}

/**
 * @param {HTMLElement} root
 */
function initBlock(root) {
    const appContainer = root.querySelector('.sendlist-appContainer');
    if (!appContainer) {
        return;
    }
    const props = JSON.parse(root.dataset.props || '{}');
    const app = createApp(SendlistApp, props);
    app.mount(appContainer);
}
